import type { ProductPriceType, StockStatusElements } from "@jti/fe-common";
import type { IMoneyMultiplier, ISpecialOffer } from "@jti/magento";
import type { ApiMagentoPriceTier, ApiMagentoProductTypeName, MagentoStockStatus } from "@jti/magento-types";

import type { MultipacksQuantity } from "@product-details/common.types";

export type ProductData = {
  isProductDataLoading: boolean;
  isProductDataLoaded: boolean;
  elementsStockStatus: StockStatusElements;
  siblingItemsStockStatus: StockStatusElements;
  isFetchingSiblingItemsStockStatus: boolean;
  isInStock: boolean;
  stockStatus: MagentoStockStatus;
  priceInformation: ProductPriceType | null;
  discount: number | null;
  priceTiers: ApiMagentoPriceTier[];
  singleProductPrice: number | null;
  elementsDynamicGalleryUrls: Record<string, string>;
  productType: ApiMagentoProductTypeName | null;
  specialOffer?: ISpecialOffer;
  multipacksQuantities: MultipacksQuantity[];
  finalPrices: Pick<IMoneyMultiplier, "value" | "currency" | "multiplier">[];
  flavor: number | null;
  subtitle: string;
  productDisclaimer: string | null;
  color: number | null;
};

export type UseProductDataOptions = {
  sku: string;
  pageSize?: number;
  isTrial?: boolean;
  currentVariantSku: string;
  categoriesSKUList?: string[];
  isDynamicGalleryEnabled?: boolean;
};
